module.exports = __webpack_public_path__ + "static/media/30OIOS11.0819a15b.jpg";